import apiClient from '../base/apiClient';
import { Municipality, TransactionItem } from './types';

export const transactionHistoryApi = {
    getUserTransactionsByQuery: async (params: { 
        userIds?: string; 
        transactionTypes?: string; 
        filter?: string; 
        page?: number; 
        perPage?: number 
        }) => {
        const { userIds = '', transactionTypes = '', filter = '', page = 0, perPage = 100 } = params;
        
        const response = await apiClient.get(`/Administration/Transaction/QueryTransactions`, {
            params: { 
            userIds, 
            transactionTypes, 
            filter, 
            page, 
            count: perPage 
            },
            withCredentials: true,
        });
        
        if (response.data.errorMessage) {
            throw new Error(response.data.errorMessage);
        }
        if (response.data.error) {
            throw new Error(response.data.error);
        }
        
        const transactions = response.data.transactions || [];
        return {
            data: transactions.map((transaction: TransactionItem) => ({
                id: transaction.transactionId,
                ...transaction,
            })),
            total: response.data.total || transactions.length,
        };
    },
    getReportMunicipalities : async () => {
        const response = await apiClient.get(`/Administration/Report/GetMunicipalityStats`, {
            withCredentials: true,
        });
        
        if (response.data.errorMessage) {
            throw new Error(response.data.errorMessage);
        }
        if (response.data.error) {
            throw new Error(response.data.error);
        }

        const municipalities = response.data.municipalities || [];
        
        return {
            data: municipalities.map((municipality: Municipality) => ({
                ...municipality,
            })),
        };
    }
}